// src/PrivacyPolicy.js
import React from 'react';
import './privacypolicy.css';

const PrivacyPolicy = () => {
  return (
    <div className="privacy-policy">
      <h1>Privacy Policy</h1>
      <p><strong>Effective Date:</strong> August 29, 2025</p>

      <p>
        Thank you for choosing Spider. Your privacy is important to us, and we are committed
        to protecting the personal information you share with us. This Privacy Policy outlines how
        we collect, use, and safeguard your information when you use our mobile application
        ("Spider", "we", "our", or "us").
      </p>

      <h2>1. Information We Collect</h2>
      <h3>a. Personal Information</h3>
      <ul>
        <li>Full name (optional)</li>
        <li>Email address</li>
        <li>Password</li>
        <li>Username for app access</li>
        <li>One-Time Password (OTP) verification for password reset</li>
      </ul>

      <h3>b. Device & Usage Data</h3>
      <ul>
        <li>Device type and OS version</li>
        <li>App interactions (e.g., shortcuts created)</li>
        <li>Default apps selected within Spider</li>
      </ul>

      <h2>2. How We Use Your Information</h2>
      <ul>
        <li>Register and authenticate users</li>
        <li>Send password reset OTPs</li>
        <li>Allow you to select and manage app shortcuts</li>
        <li>Ensure secure access to Spider using an additional username and password</li>
        <li>Improve and maintain app performance and security</li>
      </ul>

      <h2>3. Default Applications</h2>
      <p>
        Spider includes 8 pre-listed default applications for convenience. These are integrated
        within the Spider environment for quick access but do not collect additional data beyond
        usage activity within Spider.
      </p>

      <h2>4. Data Security</h2>
      <p>
        We implement appropriate technical and organizational measures to protect your data
        against unauthorized access, alteration, disclosure, or destruction. All sensitive data
        (including passwords) is securely encrypted and stored.
      </p>

      <h2>5. Data Sharing & Third Parties</h2>
      <p>We do not sell, rent, or trade your personal data to third parties. We may share your information only:</p>
      <ul>
        <li>To comply with legal obligations</li>
        <li>To protect and defend our rights</li>
        <li>With service providers that assist with secure data storage and delivery of OTPs</li>
      </ul>

      <h2>6. User Controls</h2>
      <p>You have the right to:</p>
      <ul>
        <li>Access your account information</li>
        <li>Update your email or password</li>
        <li>Delete your account and associated data (by request)</li>
      </ul>

      <h2>7. Children's Privacy</h2>
      <p>
        Spider is not intended for use by individuals under the age of 13. We do not knowingly
        collect personal data from children under 13 years old.
      </p>

      <h2>8. Changes to This Policy</h2>
      <p>
        We may update this Privacy Policy from time to time. We encourage users to check this page
        regularly for any changes. Continued use of Spider after any modifications constitutes your
        acceptance of the revised policy.
      </p>

      <h2>9. Contact Us</h2>
      <p>
        If you have any questions, concerns, or requests related to this Privacy Policy or your data,
        please contact us at:
      </p>
      <p><strong>Email:</strong> brandon.alridge84@gmail.com</p>
    </div>
  );
};

export default PrivacyPolicy;
